import {
  Button,
  TableCell,
  TableRow,
  Tooltip
} from '@mui/material';
import SvgColor from '@src/components/svg-color';
import numeral from 'numeral';

const icon = (name: string) => <SvgColor src={`/assets/icons/raffle-draw/${name}.svg`} sx={{ width: 20, height: 20 }} />;

const TableRowItem = (props: any) => {

  return (
    <TableRow hover tabIndex={-1} role="checkbox">
      <TableCell sx={{ fontWeight: 700, color: "#2D60FF" }} align="left">{props.place}</TableCell>
      <TableCell align="center" >{props.user?.id}</TableCell>
      <TableCell align="center" >{props.user?.displayName}</TableCell>
      <TableCell align="center">{numeral(props.totalRedeemedTickets).format("0,000")}</TableCell>
      <TableCell align="center" >
        <Tooltip title="Update Results" arrow>
          <Button onClick={props.onOpenEdit} sx={{color: "#457DBF"}}>{icon("edit")}</Button>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}

export default TableRowItem;
